<template>
  <section class="voting-trends-highlights">
    <transition name="fade" mode="out-in">
      <InsightsLoading v-if="isLoading" centered/>
      <div key="error" v-else-if="hasError" class="text-center pt-8 text-red-700">Couldn't load highlights</div>
      <div key="content" v-else-if="highlights">
        <p class="py-2">
          All-time voting totals and milestones
        </p>
        <div class="voting-trends-main-highlights">
          <div class="voting-trends-main-highlight robotoB">Total Votes: {{ formatNumbers(highlights.totalVotes) }}</div>
          <div class="voting-trends-main-highlight robotoB"><i class="common-icon text-3xl">+</i> Up Votes:
            <span class="text-upVotesBlue">{{ formatNumbers(highlights.totalUpVotes) }}</span>
            ({{ upVotesPercentage.toFixed(1) }}%)
          </div>
          <div class="voting-trends-main-highlight robotoB"><i class="common-icon text-3xl">-</i> Down Votes:
            <span class="text-downVotesRed">{{ formatNumbers(highlights.totalDownVotes) }}</span>
            ({{ downVotesPercentage.toFixed(1) }}%)
          </div>
        </div>
        <div class="voting-trends-more-highlights">
          <table>
            <tbody>
            <tr>
              <td>Most Votes</td>
              <td class="text-right">{{ formatHighlightNumber(highlights.mostVotes.value) }}</td>
              <td class="text-center">{{ renderHighlightDate(highlights.mostVotes.date) }}</td>
            </tr>
            <tr>
              <td>Most Up Votes</td>
              <td class="text-right">{{ formatHighlightNumber(highlights.mostUpVotes.value) }}</td>
              <td class="text-center">{{ renderHighlightDate(highlights.mostUpVotes.date) }}</td>
            </tr>
            <tr>
              <td>Most Down Votes</td>
              <td class="text-right">{{ formatHighlightNumber(highlights.mostDownVotes.value) }}</td>
              <td class="text-center">{{ renderHighlightDate(highlights.mostDownVotes.date) }}</td>
            </tr>
            </tbody>
          </table>
          <table>
            <tbody>
            <tr>
              <td>Highest Sentiment</td>
              <td class="text-right">{{ highlights.highestSentiment.value.toFixed(1) }}%</td>
              <td class="text-center">{{ renderHighlightDate(highlights.highestSentiment.date) }}</td>
            </tr>
            <tr>
              <td>Lowest Sentiment</td>
              <td class="text-right">{{ highlights.lowestSentiment.value.toFixed(1) }}%</td>
              <td class="text-center">{{ renderHighlightDate(highlights.lowestSentiment.date) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import {formatNumbers} from '@/lib/utils';

const MONTHS = [
  '',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export default {
  name: 'VotingTrendHighlights',
  props: {
    highlights: {
      type: Object
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    upVotesPercentage() {
      if (!this.highlights || !this.highlights.totalVotes) {
        return 0;
      }
      return this.highlights.totalUpVotes * 100 / this.highlights.totalVotes;
    },
    downVotesPercentage() {
      if (!this.highlights || !this.highlights.totalVotes) {
        return 0;
      }
      return 100 - this.upVotesPercentage;
    }
  },
  methods: {
    renderHighlightDate({month, year} = {}) {
      if (!MONTHS[month]) {
        return '-';
      }
      return `${MONTHS[month]} ${year}`;
    },
    formatHighlightNumber(value) {
      if (!value) {
        return '-';
      }
      return this.formatNumbers(value);
    },
    formatNumbers
  }
};
</script>

<style lang="postcss">
.voting-trends-highlights {
  @apply relative;
  min-height: 232px;

  .voting-trends-main-highlights {
    @apply flex w-full justify-between items-center;
    height: 60px;
    background-color: #F2F2F2;
    border-radius: 10px;
    padding: 0 22px;
    font-size: 17px;
    line-height: 27px;

    .voting-trends-main-highlight {
      @apply inline-flex items-center;

      > * {
        @apply mx-1;
      }
    }
  }

  .voting-trends-more-highlights {
    font-size: 18px;
    line-height: 27px;
    @apply flex flex-col md:flex-row justify-between items-start;

    table {
      @apply flex-auto w-full mt-5 mb-4;

      td {
        @apply py-1;

        &:first-child {
          @apply w-1/2;
        }
      }
    }
  }
}
</style>